// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"DeviceDetails_buttonWrapper__ID-R3","text":"DeviceDetails_text__BPt52"};